import { api } from '@api'
import { BlockTrainFileType } from '@types'

interface GetBlockTrainFileTypesResponse {
  blockTrainFileTypes: BlockTrainFileType[]
}

const getBlockTrainFileTypes = async () => {
  const response = await api.get<GetBlockTrainFileTypesResponse>('/blocktrain-file-type')
  return response.data.blockTrainFileTypes
}

export const BlockTrainFileTypeApi = {
  getBlockTrainFileTypes,
}
